<script>
  export let message = "";
  export let visible = false;

  import { onMount } from "svelte";

  let toastTimeout;

  onMount(() => {
    return () => {
      clearTimeout(toastTimeout);
    };
  });

  $: if (visible) {
    clearTimeout(toastTimeout);
    toastTimeout = setTimeout(() => {
      visible = false;
    }, 3000); // Hide the toast after 3 seconds (3,000 milliseconds)
  }
</script>

<div class="toast flex justify-between" class:show="{visible}">
  <p>{message}</p>
  <button class="close-icon justify-self-end" on:click={() => visible = false}><i class="si-solid si-xmark"></i></button>
</div>

<style>
  /* .toast {
    position: fixed;
    bottom: 20%;
    right: -100%;
    background-color: #EB5757;
    color: #fff;
    padding: 12px 16px;
    padding-right: 30px;
    border-radius: 8px;
    opacity: 0.9;
    z-index: 1000;
    font-weight: 700;
    transition: right 0.5s ease-in-out;
  } */

  .toast.show {
    right: 16px; /* Show from the right */
  }

  .close-icon {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
  }
</style>